(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sonex-product-room-entry"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sonex-product-room-entry')) {
    customElements.define('sonex-product-room-entry', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const link = this.querySelector('a');
        const update = () => {
          const container = this.closest('.shopify-section');
          const input = container?.querySelector('form[action*="/cart/add"] [name="id"]');
          if (input?.value) {
            const url = new URL(link.href);
            url.searchParams.set('variant', input.value);
            link.href = url.href;
          }
        };
        link.addEventListener('click', update);
        link.addEventListener('pointerdown', update);
        link.addEventListener('focus', update);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
